import { ArrowUturnRightIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/daisy';
import { twMerge } from 'tailwind-merge';

type FlipBtnProps = {
  onFlip?: () => void;
  flipPlaceholder?: string;
};

export const FlipBtn = ({ onFlip, flipPlaceholder }: FlipBtnProps) => {
  return (
    <div className="absolute z-20 flex w-80 justify-end">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onFlip}
        className={twMerge(
          'rounded-2xl mx-5 mt-5 font-normal',
          !onFlip && 'pointer-events-none',
        )}
      >
        {flipPlaceholder}
        <ArrowUturnRightIcon className="size-4 rotate-180" />
      </Button>
    </div>
  );
};
